import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import useReveal from '../useReveal';
import { trackEvent } from '../../../utils/analytics';
import './AIEClose.css';

/**
 * AIEClose — the final dark CTA beat. Label = ctaLabel ("Get started" since Sep 7 2026, was "Hire your AI employee").
 *
 * `demoPage` (Nov 1 2026, Nitish): when set, a "Book a demo" secondary sits beside the primary and opens
 * /book-a-demo. Home passes "/" and /ai-employees passes "/ai-employees"; other pages leave it unset.
 * It moved here from the header, where it switched those two pages to a different header layout.
 * Tracking keeps the same series: cta_click {cta_name: 'book_demo', page: demoPage, location: 'close'}.
 */
const AIEClose = ({ ctaLabel, onPrimary, title, sub, demoPage }) => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-close" ref={ref}>
      <div className="aie-close__glow" aria-hidden="true" />
      <div className={`aie-close__inner aie-reveal ${visible ? 'is-visible' : ''}`}>
        <h2 className="aie-close__title aie-display">
          {title || 'Hire your first AI employee.'}
        </h2>
        <p className="aie-close__sub">
          {sub || (
            <>
              They show up with a name, an inbox, and the judgment to run the work
              you don&rsquo;t have time for. They start tonight.
            </>
          )}
        </p>
        <div className={`aie-close__actions${demoPage ? ' aie-close__actions--pair' : ''}`}>
          <button
            type="button"
            data-msc-suppress
            className="aie-btn aie-btn-primary aie-close__cta"
            onClick={onPrimary}
          >
            {ctaLabel}
            <ArrowRightOutlined />
          </button>
          {demoPage && (
            <Link
              to="/book-a-demo"
              data-msc-suppress
              className="aie-btn aie-close__demo"
              onClick={() => trackEvent('cta_click', { cta_name: 'book_demo', page: demoPage, location: 'close' })}
            >
              Book a demo
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default AIEClose;
